(() => {
  const ROTATION_INTERVAL = 3000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (root) => {
    if (root.dataset.pzrRotationReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-pzr-hero-slide]'));
    if (slides.length < 2) return;

    root.dataset.pzrRotationReady = 'true';
    let activeIndex = 0;
    let timer = null;
    let isHovered = false;
    let isIntersecting = true;

    const show = (nextIndex) => {
      slides.forEach((slide, index) => {
        const isActive = index === nextIndex;
        slide.classList.toggle('is-active', isActive);
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      activeIndex = nextIndex;
    };

    const stop = () => {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (reducedMotion.matches || document.hidden || isHovered || !isIntersecting) return;
      timer = window.setInterval(() => show((activeIndex + 1) % slides.length), ROTATION_INTERVAL);
    };

    root.addEventListener('mouseenter', () => {
      isHovered = true;
      stop();
    });
    root.addEventListener('mouseleave', () => {
      isHovered = false;
      start();
    });
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) show(0);
      start();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        isIntersecting = entry.isIntersecting;
        start();
      }, { rootMargin: '200px 0px' });
      observer.observe(root);
    }

    show(0);
    start();
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-pzr-hero-rotation]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
